import { MessageKey } from "../message-key.js";
export const pt = {
    [MessageKey.accountAlreadyConfirmed]: `Conta já confirmada.`,
    [MessageKey.accountAlreadyExists]: `A conta já existe e está confirmada.`,
    [MessageKey.accountConfirmed]: `Conta confirmada com sucesso! Agora você pode entrar.`,
    [MessageKey.accountCreated]: `Conta criada. Um e-mail de confirmação foi enviado.`,
    [MessageKey.accountData]: `Dados da conta autenticada.`,
    [MessageKey.accountNotConfirmed]: `Confirme sua conta para continuar.`,
    [MessageKey.accountNotFound]: `Conta não encontrada.`,
    [MessageKey.accountPendingConfirmation]: `A conta já existe mas não está confirmada.`,
    [MessageKey.confirmationEmailSent]: `E-mail de confirmação enviado.`,
    [MessageKey.confirmationTooSoon]: `E-mail de confirmação enviado recentemente. Tente mais tarde.`,
    [MessageKey.confirmationTryAfterMinutes]: `A conta ainda não foi confirmada. Tente fazer login novamente em {minutes} minutos para receber outro link de confirmação.`,
    [MessageKey.healthOk]: `Serviço está saudável.`,
    [MessageKey.incorrectOldPassword]: `Senha antiga incorreta.`,
    [MessageKey.internalServerError]: `Erro interno do servidor.`,
    [MessageKey.invalidCredentials]: `E-mail ou senha incorretos.`,
    [MessageKey.invalidEmail]: `Endereço de e-mail inválido.`,
    [MessageKey.loginSuccessful]: `Você entrou.`,
    [MessageKey.logoutSuccessful]: `Logout realizado com sucesso.`,
    [MessageKey.notAuthenticated]: `Você precisa entrar para continuar.`,
    [MessageKey.passwordChanged]: `Senha alterada com sucesso.`,
    [MessageKey.passwordReset]: `Senha redefinida com sucesso.`,
    [MessageKey.resetEmailSent]: `Se a conta existir e estiver confirmada, um e-mail de redefinição foi enviado.`,
    [MessageKey.resetTokenInvalid]: `Token de redefinição inválido.`,
    [MessageKey.resetTokenMissing]: `Token de redefinição não encontrado. Solicite um novo.`,
    [MessageKey.resetTooSoon]: `E-mail de redefinição enviado recentemente. Tente mais tarde.`,
    [MessageKey.routeNotFound]: `Rota não encontrada.`,
    [MessageKey.sessionInvalid]: `Sua sessão expirou. Por favor entre novamente.`,
    [MessageKey.tokenMismatch]: `Token de confirmação não corresponde.`,
    [MessageKey.tokenNotFound]: `Token de confirmação não encontrado.`,
    [MessageKey.invalidTurnstileToken]: `Token do Turnstile inválido.`,
    [MessageKey.missingTurnstileToken]: `Token do Turnstile ausente.`,
    [MessageKey.turnstileVerificationFailed]: `A verificação do Turnstile falhou.`,
    [MessageKey.accountPreferences]: `Preferências do usuário.`,
    [MessageKey.accountPreferencesUpdated]: `Preferências do usuário atualizadas.`,
    [MessageKey.accountProfileUpdated]: `Perfil da conta atualizado.`,
    [MessageKey.forbiddenOrigin]: `Proibido: origem não permitida`,
    [MessageKey.forbiddenOriginSecret]: `Proibido: segredo de origem inválido ou ausente`,
};
//# sourceMappingURL=pt.js.map